import styled from 'styled-components';
import ReCAPTCHA from 'react-google-recaptcha';

const GoogleRecaptcha = styled(ReCAPTCHA)`
  display: flex;
  justify-content: center;
  margin: 1rem 0;
  @media (max-width: 600px) {
    transform:scale(0.77);
  }
`;

export default GoogleRecaptcha;


// WEBPACK FOOTER //
// ./src/components/Form/GoogleRecaptcha.js